// extracted by mini-css-extract-plugin
export default {"container":"MobileBackgroundLayer_container__Ju+JZ"};